module.exports = __webpack_public_path__ + "img/c8bb542.png";